import { apiFetch } from "./client";

export interface Approval {
  id: string;
  companyId: string;
  title: string;
  description: string | null;
  status: string;
  requestedByAgentId: string | null;
  requestedByUserId: string | null;
  decidedByUserId: string | null;
  decision: string | null;
  decidedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const approvalsApi = {
  list: (companyId: string) => apiFetch<Approval[]>(`/approvals?companyId=${companyId}`),
  get: (id: string) => apiFetch<Approval>(`/approvals/${id}`),
  create: (data: Record<string, unknown>) =>
    apiFetch<Approval>("/approvals", { method: "POST", body: JSON.stringify(data) }),
  decide: (id: string, decision: "approved" | "rejected") =>
    apiFetch<Approval>(`/approvals/${id}/decide`, { method: "POST", body: JSON.stringify({ decision }) }),
  delete: (id: string) => apiFetch<void>(`/approvals/${id}`, { method: "DELETE" }),
};
